import { TextAppearanceKeys, TextEmphasisKeys, TextSizeKeys } from '@/constants/enum';
import { textAppereances, textEmphasis, textSizes } from '@/constants/textStyles';

export const handleGetTextSize = (size: TextSizeKeys) => {
  return textSizes.find((s) => s.id === size)?.fontSize || 'var(--typography-font-size-base, 14px)';
};

export const handleGetTextColor = (size: TextAppearanceKeys) => {
  return textAppereances.find((s) => s.id === size)?.color || '#303030';
};

export const handleGetTextEmphasis = (size: TextEmphasisKeys) => {
  return textEmphasis.find((s) => s.id === size)?.style || '400';
};
